import { blobResponse } from "Components/constants/Common";
import {
  ADDPOWITHRO,
  ADDRATE,
  DELETEPOWITHRO,
  LISTOFPO,
  LISTOFRATE,
  LISTOFSTOCK,
  PURCHASE_ORDER_PDF,
  UPDATEPOSTATUS,
  UPDATEPOWITHRO,
  VIEWPOWORO,
  VIEWPRWITHRO,
} from "./ApiRoutes";
import { authData } from "./services";

export const addPOwithRO = async (data: object) => {
  const response = await authData.post(ADDPOWITHRO, data);
  return response?.data;
};

export const getViewPO = async (id: number) => {
  const response = await authData.get(`${VIEWPRWITHRO}/${id}`);
  return response?.data;
};

export const getViewPOWORO = async (id: number) => {
  const response = await authData.get(`${VIEWPOWORO}/${id}`);
  return response?.data;
};

export const listOfPO = async (data: object) => {
  const response = await authData.post(LISTOFPO, data);
  return response?.data;
};

export const deletePO = async (id: number) => {
  const response = await authData.delete(`${DELETEPOWITHRO}${id}`);
  return response?.data;
};

export const updatePO = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATEPOWITHRO}/${id}`, data);
  return response?.data;
};

export const updatePOStatus = async (id: number) => {
  const response = await authData.put(`${UPDATEPOSTATUS}${id}`);
  return response?.data;
};

export const POPdfApi = async (id: number) => {
  const response = await authData.get(`${PURCHASE_ORDER_PDF}${id}`, blobResponse);
  return response;
};

export const listOfRate = async (data: object) => {
  const response = await authData.post(LISTOFRATE, data);
  return response?.data;
};

export const addRate = async (data: object) => {
  const response = await authData.post(ADDRATE, data);
  return response?.data;
};

export const listOfStock = async (id: number) => {
  const response = await authData.get(`${LISTOFSTOCK}/${id}`);
  return response?.data;
};